import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import { EditSelectionService } from '../edit-selection.service';
import {QuestionState} from '../models';
import {QuestionPubSub} from '../question-runner/pubsub/question-pubsub';
import { IContentElementTable } from './model';

@Component({
  selector: 'element-render-table',
  templateUrl: './element-render-table.component.html',
  styleUrls: ['./element-render-table.component.scss'],
})
export class ElementRenderTableComponent implements OnInit {

  @Input() element:IContentElementTable;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;
  @Input() questionPubSub?: QuestionPubSub;

  constructor(
    public editSelection: EditSelectionService
  ) { }

  ngOnInit() {
  }

  checkHeaderByIndex(i:number){
    if (this.element.isHeaderRow && i === 0){
      return true;
    }
  }

  checkColHeaderByIndex(i:number){
    if (this.element.isHeaderCol && i === 0){
      return true;
    }
  }

  isHeaderCell(rowIndex:number, colIndex:number){
    return !!(this.checkHeaderByIndex(rowIndex) || this.checkColHeaderByIndex(colIndex));
  }

  getHeaderScope(rowIndex:number, colIndex:number){
    if (this.element.isHeaderCol && colIndex === 0 && rowIndex !== 0){
      return 'row';
    }
    if (this.element.isHeaderRow && rowIndex === 0 && colIndex !== 0){
      return 'col';
    }
    if (this.element.isHeaderRow && rowIndex === 0 && !this.element.isHeaderCol){
      return 'col';
    }
    if (this.element.isHeaderCol && colIndex === 0 && !this.element.isHeaderRow){
      return 'row';
    }
    return null;
  }

  parseCellAlignment(align:string){
    switch(align){
      case 'left': return 'left';
      case 'right': return 'right';
      default:
      case 'center': return 'center';
    }
  }

  getColWidth(col_i:number){
    if (this.element.isColWidthConst && this.element.colWidthConst){
      return this.element.colWidthConst;
    }
  }

}
